import React from "react";
import "./AdminDashboardWrapper.css";
import AdminNavbar from "../Navbar/Navbar";
import Footer from "../../../ClientDashboard/Components/Footer/Footer";
import { Outlet } from "react-router-dom";
const AdminDashboardWrapper = () => {
  return (
    <div className="admin__dashboard_wrap">
      <AdminNavbar />
      <div className="admin__dashboard_container">
        <div className="admin__dashboard_subcontainer">
          {" "}
          <Outlet />
        </div>
      </div>
      <Footer style={{ backgroundColor: "rgba(4, 153, 151, 1)" }} />
    </div>
  );
};

export default AdminDashboardWrapper;
